import { ChevronDown } from "lucide-react";

export interface StatusOption {
  label: string;
  value: string;
}

interface StatusFilterProps {
  label?: string;
  value: string;
  options: StatusOption[];
  onChange: (value: string) => void;
}

export default function StatusFilter({
  label = "Status",
  value,
  options,
  onChange,
}: StatusFilterProps) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">{label}</label>

      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full appearance-none rounded-lg border border-gray-300 bg-white px-3 py-2 pr-10 text-sm focus:border-blue-500 focus:outline-none">
          <option value="">All Status</option>

          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <ChevronDown
          size={18}
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
      </div>
    </div>
  );
}
